<template>
  <div class="my-form">
    <img class="background-img" :src="currentBackground" alt="">
    <!-- 横屏 -->
    <div class="info">
      <div class="top-box">
        <!-- <img src="/assets/~/media/images/activity/policy2503/pc/kn.png" alt=""> -->
        <!-- <div class="top-text">心之所向 起亚相伴</div>
        <div class="top-text1">即刻试驾 开启新程</div> -->
        <img src="/assets/~/media/images/activity/film2505-prod/pc/pcform-text.png" alt=""> 
      </div>
      <el-form :inline="true" class="demo-form-inline" :model="driveForm" ref="driveForm">
            <el-form-item label="*所在省份">
              <el-select v-model="driveForm.Province" placeholder="选择省份" @change="setProvince">
                <el-option v-for="(item, key) in alldata.province" :value="item.id" :key="key" :label="item.name">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="*所在城市">
              <el-select v-model="driveForm.City" placeholder="选择城市" no-data-text="无" @click="setCity()"
                code-stm="event, PAGEURL, 切换城市信息pc" @change="cityChange">
                <el-option v-for="(item, key) in this.cascadingCities" :value="item.id" :key="key" :label="item.name">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="*经销商">
              <el-select
                v-model="driveForm.DealerCode"
                placeholder="请选择经销商"
                no-data-text="无"
                @change="dealerChange"
                popper-class="select-option-dealer"
              >
                <el-option
                  v-for="(item, key) in this.cascadingDealers"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                  :disabled="item.isDisabled"
                >
                <template #default>
                  <div  style="display: flex;align-items: start;padding: 5px 0;">
                    <i v-if="driveForm.DealerCode == item.code" class="el-icon-check" style="padding-top: 10px;font-weight: 700;"></i>
                    <div v-else style="width: 14px;height: 14px;"></div>
                    <div style="padding-left: 10px;" >
                      <div>{{ item.name }}</div>
                      <div style="color: rgba(180, 183, 192, 1);font-size: 12px;line-height: 20px;">{{ item.address }}</div>
                    </div>
                  </div>
                </template>
              </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="*车型">
              <el-select v-model="driveForm.CarSeriesCMSID" placeholder="请选择车型" @change="setCarSeries">
                <el-option v-for="(item, key) in carAlldata.series" :key="key" :value="item.cmsid" :label="item.name">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="*购车人姓名">
              <el-input v-model="driveForm.Name" placeholder="请输入姓名"></el-input>
            </el-form-item>

            <el-form-item label="*购车人手机号">
              <el-input v-model="driveForm.Phone" placeholder="请输入手机号" maxlength="11"
                oninput="if(value.length > 11) value=value.slice(0, 11)"></el-input>
            </el-form-item>
            <!-- 新增验证码 start -->
            <div id="captcha-element1"></div>
            <el-row>
            <el-form-item label="*验证码"> 
              <el-col :span="17" style="height:100%">
              <el-input
                placeholder="请输入验证码"
                class="input"
                type="text"
                v-model="driveForm.verificationCode"
                style="display: inline-block; width: 60%"
                maxlength="6"
                oninput="if(value.length > 6) value=value.slice(0, 6)"
              />
              </el-col>
              <el-col :span="7" style="height:100%">
              <el-button
                class="button"
                id="buttonAliyunCaptcha1"
                :disabled="!this.countDownCanClick"
                code-stm="event, PAGEURL, 获取验证码pc"
                :class="{ disabled: !this.countDownCanClick }"
                style="width: 0;height: 100%;font-size: calc(16 / 1920 * 100vw);padding: 0;background-color: #fff;color:#000"
                >{{ countDownContent }}</el-button
              >
              </el-col>
            </el-form-item>
            </el-row>
            <!-- 新增验证码 end -->


          <el-checkbox v-model="driveForm.checked" className="agreement-checkbox" style="margin-top:20px" @change="checkboxChange">
            <span style="display: flex;color: #05141F99;white-space: nowrap;">
              已阅读并同意
              <span style="text-decoration: underline;color: #05141F;white-space: nowrap;" @click="read" code-stm="event, PAGEURL, 隐私协议">
                《隐私协议》
              </span>
              ，且同意起亚经销商与我联系。
            </span>
          </el-checkbox>

        <span class="submit-button" @click="submitInformation" >提交信息</span>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getUrlKey, isPortraitFun, isSafariFun, isPc } from "@/utils/utils.js";
import { apiUrl, pcdUrl, CSMUrl } from "@/config/base";
import $ from 'jquery'
export default {
  props: {
    clientPosition: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      captcha: null,
      
      isSafari: isSafariFun(),
      alldata: null,
      carAlldata: null,

      carModelSeries: [],
      cascadingCities: [],
      cascadingDealers: [],
      // canCheck: false,
      totalTime: 60,
      countDownContent: "获取验证码",
      countDownCanClick: true,
      clock: null,
      driveForm: {
        //试驾
        Phone: "",
        Name: "",
        verificationCode: "",
        Province: "",
        City: "",
        CarSeriesCMSID:'447',
        CarSeriesName: "新狮铂拓界",
        CarModelCMSID: "1617",
        CarModelName: "1.5T 舒适版",
        DealerName: "",
        DealerCode: "",
        checked: false,
      },
      isPc: isPc(),

      // downArrowIcon: require("@/assets/images/footer/down-arrow.gif"),
      currentBackground:'/assets/~/media/images/activity/film2505-prod/pc/pcform-bg.jpg',
    };
  },
  watch: {
    // 地址定位
    clientPosition: {
      handler(val) {
        // 防止定位完成省市信息没有加载完成
        if (!this.alldata) {
          this.$axios.get(pcdUrl).then((res) => {
            this.alldata = res.data;
            this.initData();
            if (val) {
              this.driveForm.Province = this.alldata.province.filter(
                (item) => item.name == val.province
              )[0].id;
              this.driveForm.City = this.alldata.city[
                this.driveForm.Province
              ].filter((item) => item.name == val.city)[0].id;
              this.setCity(true);
              this.cityChange(this.driveForm.City);
            }
          });
        } else {
          if (val) {
            this.driveForm.Province = this.alldata.province.filter(
              (item) => item.name == val.province
            )[0].id;
            this.driveForm.City = this.alldata.city[
              this.driveForm.Province
            ].filter((item) => item.name == val.city)[0].id;
            this.setCity(true);
            this.cityChange(this.driveForm.City);
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created: function () {
    if (!this.alldata) {
      console.log("try to fetch alldata from created");
      this.$axios.get(pcdUrl).then((res) => {
        console.log("fetched alldata from created", res.data);

        this.alldata = res.data;
        this.initData();
      });
    }
    window.addEventListener("resize", this.setResize);
  },
  mounted() {
    this.$nextTick(() => {
      this.ensureCaptchaReady();
    });
  },
  methods: {
    ensureCaptchaReady() {
      this.waitForCaptchaElements()
        .then(() => {
          this.initCaptcha();
        })
        .catch((err) => {
          console.warn(err?.message || "captcha elements not ready");
        });
    },
    waitForCaptchaElements(retries = 30, interval = 100) {
      return new Promise((resolve, reject) => {
        const attempt = () => {
          const element = document.querySelector("#captcha-element1");
          const button = document.querySelector("#buttonAliyunCaptcha1");
          if (element && button) {
            resolve({ element, button });
            return;
          }
          if (retries <= 0) {
            reject(new Error("captcha elements missing"));
            return;
          }
          retries -= 1;
          window.setTimeout(attempt, interval);
        };
        attempt();
      });
    },

    initCaptcha() {
      console.log('initCaptcha diyici pc');
      const element = document.querySelector("#captcha-element1");
      const button = document.querySelector("#buttonAliyunCaptcha1");
      if (!element || !button) {
        console.log('element or button is null');
        return;
      }
      //***验证start
      var that = this;
      var preText = '';
      if (!window.location.href.includes("https://www.kia.cn")) {
        preText = 'https://uat.kia.cn'
      }else{
        preText = 'https://www.kia.cn'
      }
      let kiaLogoUrl = preText + '/assets/~/media/images/aliyuncaptcha/kia_logo.png';
      var captcha;
      // 弹出式，除region和prefix以外的参数
      window.initAliyunCaptcha({
      // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      SceneId: "nrr27cp0",
      // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
      mode: "popup",
      // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      element: "#captcha-element1",
      // 触发验证码弹窗或无痕验证的元素
      button: "#buttonAliyunCaptcha1",
      captchaLogoImg: kiaLogoUrl,
      // 验证码验证通过回调函数
      success: function (captchaVerifyParam) {
        // 入参为验签captchaVerifyParam
        // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
        // 2.根据校验结果来进行业务处理
        // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
          console.log('captchaVerifyParam',captchaVerifyParam);
          that.countDown(captchaVerifyParam)
      },
      // 验证码验证不通过回调函数
      fail: function (result) {
        // 入参为不通过信息
        // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
        console.error(result);
      },
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: function (instance) {
        console.log('getInstance', instance);
        that.captcha = instance;
      },
      // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。
      slideStyle: {
        width: 360,
        height: 40,
      },
      // ...其他参数，参考initAliyunCaptcha参数说明
      });
      //***验证 end */
    },

    checkboxChange(e){
      if(e == true){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '勾选', 1]);
      }else{
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '取消勾选', 1]);
      }
    },
    read() {
      // this.$router.push({
      //   path: "/terms",
      // });
      const route = this.$router.resolve({ path: '/terms' });
      const href = route.href;
      window.open(href, '_blank');
    },
    initData() {
      let that = this;
      // this.$axios.get(CSMUrl).then((res) => {
      //   console.log("车型车款数据", res.data);
      //   that.carAlldata = res.data;
      // });
      fetch(CSMUrl).then(function (response) {
        return response.json();
      }).then(function (data) {
        console.log("车型车款数据", data);
        that.carAlldata = data;
      });
    },

    setResize() {
      // console.log(13123, this.isPortrait);
    },
    setProvince() {
      this.driveForm.City = "";
      this.driveForm.DealerCode = "";
      this.driveForm.DealerName = "";
      this.cascadingDealers = [];
      this.setCity();
    },
    setCity(fromLocation = false) {
      // this.cascadingCities = this.alldata.city[this.driveForm.Province];
      this.cascadingCities = [];
      const currentCities = this.alldata.city[this.driveForm.Province] || [];
      currentCities.forEach((cityIter) => {
        //过滤city
        if (
          this.alldata.cityRelType[cityIter.id].includes("1") ||
          this.alldata.cityRelType[cityIter.id].includes("4")
        ) {
          this.cascadingCities.push(cityIter);
        }
      });
      if(!fromLocation){
        this.driveForm.City = this.driveForm.City || (this.cascadingCities.length ? this.cascadingCities[0].id : "");
      }else{
        // #如果未找到对应城市数据(因为他没有经销商 所以alldata城市字典表中没这个城市),则默认选中第一个
        // this.driveForm.City = this.cascadingCities.find((city) => city.name === this.clientPosition.city)?.id || this.cascadingCities[0].id
        if(!this.cascadingCities.find((city) => city.id === this.driveForm.City)){
            this.driveForm.City = ''
        }
      }
      this.cityChange(this.driveForm.City);
    },

    setCarSeries(e) {
      this.driveForm.CarModelCMSID = "";
      console.log(
        "this.driveForm.CarSeriesCMSID",
        this.driveForm.CarSeriesCMSID
      );
      if (this.driveForm.CarSeriesCMSID) {
        this.driveForm.CarModelCMSID =
          this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).cmsid;
        this.driveForm.CarModelName =
          this.carAlldata.model[this.driveForm.CarSeriesCMSID].at(-1).name;
      }
      console.log("this.driveForm.CarModelName", this.driveForm.CarModelName);

      //切换背景
      // var background = this.backGroundList.find(
      //   (item) => item.id == e
      // )?.background;
      // this.currentBackground = background;
    },
    async cityChange(cityId) {
      if (!cityId) {
        this.cascadingDealers = [];
        this.driveForm.DealerCode = "";
        this.driveForm.DealerName = "";
        return;
     }
      let map = await this.load();
      let baiduMap = new map.Map();
      //改变经销商数据/起点
      let temp = this.alldata.dealer[cityId] || [];
      this.cascadingDealers = [];
      temp.forEach((origin) => {
        if (origin.type == "1" || origin.type == "7") {
          const originPosition = new BMap.Point(
            origin.latitude,
            origin.longitude
          );
          const nowPosition = new BMap.Point(
            this.clientPosition.lng,
            this.clientPosition.lat
          );
          if (origin.isException !== "是" 
          && origin.name !== "上海森那美正大乐城城市展厅" && origin.name !== "武汉峻能凯德城市展厅"
          && origin.name !== "北京森那美北投城市展厅" && origin.name!== "济南金万通万达城市展厅"
          && origin.name!== "重庆现代高新南坪万达城市展厅" 
          ) {
            this.cascadingDealers.push({
              ...origin,
              distance: this.getMapDistance(
                nowPosition,
                originPosition,
                baiduMap
              ),
              isDisabled: origin.isException === "是",
            });
          }
        }
      });
      this.cascadingDealers = this.cascadingDealers.sort((a, b) => {
        // 首先处理 isException 的情况
        if (a.isException === "是" && b.isException !== "是") {
          return 1; // a 排在 b 后面
        } else if (a.isException !== "是" && b.isException === "是") {
          return -1; // b 排在 a 后面
        }
        return a.distance - b.distance;
      });
      if (this.cascadingDealers.length) {
        this.driveForm.DealerCode = this.cascadingDealers[0].code;
        this.driveForm.DealerName = this.cascadingDealers[0].name;
      }
    },

    getMapDistance(centerPoint, otherPoint, map) {
      let distance = map.getDistance(centerPoint, otherPoint);
      return (distance / 1000).toFixed(2);
    },
    dealerChange(dealerCode) {
      let dealer = this.cascadingDealers.find((value) => {
        return value.code === dealerCode;
      });
      this.driveForm.DealerCode =
        dealer == null ? this.cascadingDealers[0].code : dealer.code;
      this.driveForm.DealerName =
        dealer == null ? this.cascadingDealers[0].name : dealer.name;
    },
    countDown(captchaVerifyParam) {
      if (!this.driveForm.Phone) {
        this.initCaptcha()
        this.$message.error("请填写正确的手机号");
        return;
      }if (!/^1[3456789]\d{9}$/.test(this.driveForm.Phone)) {
        this.initCaptcha()
        this.$message.error("请填写正确的手机号");
        return;
      }
      if (!this.countDownCanClick) return; //改动的是这两行代码
      this.countDownCanClick = false;
      this.countDownContent = this.totalTime + "s后重试";
      this.clock = window.setInterval(() => {
        this.totalTime--;
        this.countDownContent = this.totalTime + "s后重试";
        if (this.totalTime < 0) {
          window.clearInterval(this.clock);
          this.countDownContent = "重新发送";
          this.totalTime = 60;
          this.countDownCanClick = true; //这里重新开启
        }
      }, 1000);
      //发送验证码
      let getCodeData = {
        phoneNumbers: this.driveForm.Phone,
        captchaVerifyParam: captchaVerifyParam,
      };
      this.$axios
        .post(`${apiUrl}sendMsg/cityTour/CaptchaSendVerificationCode`, getCodeData)
        .then((res) => {
          console.log("ressssssss", res);
          if (res.data.success) {
            this.$message.info("验证码发送成功，请注意查收");
          } else {
            this.$message.error(res.data.message);
          }
          this.initCaptcha()
        });
    },
    submitInformation() {
      if (
        !this.driveForm.Name ||
        !this.driveForm.Phone ||
        !this.driveForm.verificationCode ||
        !this.driveForm.CarSeriesCMSID
      ) {
        this.$message.error("请完善信息后再次提交");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.driveForm.Phone)) {
        this.$message.error("请填写正确的手机号");
        return;
      }
      //获取车型名字
      // console.log(this.carSeries)
      let CarSeriesName = this.carAlldata.series.find((item, index) => {
        return item.cmsid === this.driveForm.CarSeriesCMSID;
      });
      //获取默认经销商名字和编码
      if (!this.driveForm.DealerCode || !this.driveForm.DealerName) {
        this.driveForm.DealerCode = this.cascadingDealers[0].code;
        this.driveForm.DealerName = this.cascadingDealers[0].name;
      }
      //将省市转化成字符串
      let provinceStr = this.alldata.province.find(
        (item) => item.id === this.driveForm.Province
      );
      let cityStr = this.alldata.city[this.driveForm.Province].find(
        (item) => item.id === this.driveForm.City
      );
      provinceStr = provinceStr.name;
      cityStr = cityStr.name;

      if (!this.driveForm.checked) {
        this.$message.error(
          "请先同意已阅读并同意《隐私协议》，且同意起亚经销商与我联系"
        );
        return;
      }
      let currentYear= new Date().getFullYear();
      let  currentMonth = new Date().getMonth() + 1;
      let activename  = "官网-所向由心品牌电影-预约试驾";
      console.log("this.driveForm.CarModelName", activename)
      let subFormDrive = {
        //媒体来源、活动来源、媒体渠道ID没写
        carModelCmsid: this.driveForm.CarModelCMSID,
        carModelName: this.driveForm.CarModelName,
        carSeriesCmsid: this.driveForm.CarSeriesCMSID,
        carSeriesName: CarSeriesName.name,
        cityName: cityStr,
        dealerCode: this.driveForm.DealerCode,
        dealerName: this.driveForm.DealerName,
        provinceName: provinceStr,
        userName: this.driveForm.Name,
        userPhone: this.driveForm.Phone,
        verificationCode: this.driveForm.verificationCode,
        smartCode: getUrlKey("utm_source") || "官网", //媒体来源
        activity: getUrlKey("utm_activity") || activename, //活动名称
        extraSix: getUrlKey("utm_soid") || "76",
      };
      //预约试驾接口
      this.$axios
        .post(`${apiUrl}clue/newkiaAaustralia/saveClue`, subFormDrive)
        .then((res) => {
          console.log(99999998888, res);
          if (res.data.success) {
            this.$message.success("预约试驾成功");
            
            console.log(subFormDrive);
            setTimeout(() => {
              this.driveForm.CarModelCMSID = "1617";
              this.driveForm.CarSeriesCMSID = "447";
              this.driveForm.DealerCode = "";
              this.driveForm.DealerName = "";
              this.driveForm.Name = "";
              this.driveForm.Phone = "";
              this.driveForm.verificationCode = "";
              this.driveForm.City = "";
              this.driveForm.Province = "";
              this.driveForm.checked = false;
              // 重置倒计时
              window.clearInterval(this.clock);
              this.countDownContent = "获取验证码";
              this.totalTime = 60;
              this.countDownCanClick = true;

            }, 1000);
            _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),
              '活动留资线索提交成功', JSON.stringify(subFormDrive)]);
          } else {
            this.$message.error("预约试驾失败:" + res.data.message);
            _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),
              '活动留资线索提交失败', JSON.stringify(subFormDrive)]);
            console.log(subFormDrive);
            console.log(res.msg);
          }
        });
    },
    // 加载地图
    load() {
      return new Promise((resolve, reject) => {
        if (!this.BMap) {
          $.getScript(
            "//api.map.baidu.com/api?v=2.0&ak=4ybCJ1rBffkf2PFgkvsRJuqAV9XBtnHq&callback=initialize",
            function (res) {
              console.log("百度", res);
              let num = 1;
              let time = setInterval(() => {
                if (BMap.Map) {
                  this.BMap = true;
                  resolve(BMap);
                  clearInterval(time);
                }
                num++;
              }, 25);
            }
          );
        } else {
          resolve(BMap);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select-option-dealer .el-select-dropdown__item {
  height: auto !important;
  // padding: 0 10px;
  padding: 0;
}
.el-select-dropdown__item.selected {
  font-weight: 500 !important;
}
.background-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(1238 / 2200 * 100vw);
}
.my-form {
  position: relative;
  height: calc(1238 / 2200 * 100vw);
  display: flex;
  flex-direction: column;
  align-items: center;

  .close {
    position: absolute;
    top: 22px;
    right: 18px;
    width: 18px;
    height: auto;
    opacity: 1;
  }

  .info {
    // border-top: 5px solid #B08F6F;
    position: absolute;
    top: calc(209 / 2200 * 100vw);
    right: calc(236 / 2200 * 100vw);
    z-index: 10;
    width: calc(566 / 2200 * 100vw);
    height: calc(826 / 2200 * 100vw);
    // height: calc(733 / 1920 * 100vw);
    background-color: #fff;
    padding: calc(42 / 2200 * 100vw) calc(58 / 2200 * 100vw) calc(86 / 2200 * 100vw) calc(58 / 2200 * 100vw);

  }
  .top-box {
    display: flex;
    flex-direction: column;
    padding-bottom: calc(17 / 2200 * 100vw);
    img {
      // width: calc(151 / 2200 * 100vw);
      // height: calc(35 / 2200 * 100vw);
      width: calc(281 / 2200 * 100vw);
      height: calc(74 / 2200 * 100vw);
    }
    .top-text {
      font-size: 'FZLanTingHeiS-DB-GB';
      font-size: calc(34 / 2200 * 100vw);
      // padding-top: calc(17 / 2200 * 100vw);
    }
    .top-text1 {
      font-size: 'FZLanTingHeiS-R-GB';
      font-size: calc(34 / 2200 * 100vw);
      // padding-top: calc(17 / 2200 * 100vw);
    }
  }
}

.submit-button {
  width: 100%;
  display: block;
  text-align: center;
  background-color: #000000;
  color: #fff;
  font-size: calc(18 / 2200 * 100vw);
  width: calc(450 / 2200 * 100vw);
  height: calc(57 / 2200 * 100vw);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: calc(54 / 2200 * 100vw);
  cursor: pointer;
}

.el-button {
  width: 100%;
  background: #19191C;
  border-radius: 0px;
  height: 50px;
  color: #fff;
  border: none;
}

::v-deep .el-checkbox__label  {
  padding-left: calc(10 / 2200 * 100vw);
}
::v-deep .el-checkbox__label span {
  display: block;
  color: #a7a7a7;
  margin-top: calc(28 / 2200 * 100vw);
  font-size: calc(16 / 2200 * 100vw);
}

::v-deep .el-checkbox__inner {
  background: transparent;
  border: 1px solid rgba($color: #19191C, $alpha: 0.3);
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19191C;
  border-color: #19191C;
}

::v-deep .el-form-item {
  margin: 0;
  width: 100%;
  display: flex;
  border-bottom:solid 1px #EEEEEE;
  height: calc(66 / 2200 * 100vw);
}

::v-deep .el-form-item__content {
  // width: 100%;
  width: calc(330 / 2200 * 100vw);;
  .inline-txt {
    position: absolute;
    line-height: 50px;
    // padding: 0 10px;
    padding: 0;
    color: #3d3d3d;
  }
}
::v-deep .el-select {
  width: 100%;

  .el-input__inner {
    width: 12.8vw;
    // padding: 0 10px;
    padding-left: calc(20 / 2200 * 100vw);
    padding-right: 0;
  }
}

::v-deep .el-input__inner {
  border-radius: 0px;
  height: calc(66 / 2200 * 100vw);
  line-height: calc(66 / 2200 * 100vw);
  background: transparent;
  border: none !important;
  color: #3d3d3d;
  padding-left: calc(20 / 2200 * 100vw);
  padding-right: 0;
  font-size: calc(20 / 2200 * 100vw);
}

::v-deep .el-form--inline .el-form-item__label {
  display: block;
  text-align: left;
  font-size: calc(20 / 2200 * 100vw);
  width: calc(120 / 2200 * 100vw);
  padding: 0;
  color: #666666;
  font-weight: 400;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: start;
}

::v-deep .el-checkbox__input {
  vertical-align: top;
}

::v-deep .el-checkbox__label span {
  display: block;
  margin-top: 0px;
  white-space: pre-wrap;
}
.disabled {
  color: #a7a7a7 !important;
}
</style>
